module.exports = __webpack_public_path__ + "media/images/front/event/book-icon-9ecb9961e09499b36e5393d5835bba36.svg";